import { render, staticRenderFns } from "./GeneralProps.vue?vue&type=template&id=0654b08a&scoped=true"
import script from "./GeneralProps.vue?vue&type=script&lang=ts"
export * from "./GeneralProps.vue?vue&type=script&lang=ts"
import style0 from "./GeneralProps.vue?vue&type=style&index=0&id=0654b08a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654b08a",
  null
  
)

export default component.exports